<template>
  <NumeraiModal
    ref="modal"
    :dialog="dialog"
    :button="false"
    title="Upload Model"
    :show-footer="false"
    :disabled="isUploading"
    @close="close"
  >
    <template v-slot:activator>
      <slot></slot>
    </template>
    <v-select
      :items="modelSelectItems"
      :value="modelName"
      :disabled="isUploading"
      label="Select a model"
      class="mt-4"
      @change="onModelChange"
    >
    </v-select>
    <p v-if="errorMessage" class="error-message mb-0">{{ errorMessage }}</p>
    <div class="mb-2"></div>
    <div class="modal-group buttons-container pt-2 flexrow justify_end">
      <button class="numerai-button button-tertiary" @click="close">
        Close
      </button>
      <button
        :disabled="!selectedModel || isUploading"
        class="numerai-button upload-button ml-4"
      >
        <v-icon v-if="isUploading" dark class="loading-spinner"
          >mdi-cached</v-icon
        >
        <span v-if="!selectedModel && !isUploading">{{ uploadText }}</span>
        <NumeraiUploadFile
          v-if="selectedModel && !isUploading"
          :auth-endpoint="this.$client.getModelUploadAuth"
          :create-endpoint="this.$client.createModelUpload"
          :model-id="selectedModel && selectedModel.id"
          created-text="Uploading..."
          success-text="Upload accepted"
          :on-upload-start="onModelUploadStart"
          :on-upload-end="onModelUploadEnd"
          :on-success="handleSuccess"
          :on-failure="handleFailure"
          :source="source"
          @click="track('clicked', 'upload model')"
        >
          {{ uploadText }}
        </NumeraiUploadFile>
      </button>
    </div>
  </NumeraiModal>
</template>

<script>
import { mapActions } from 'vuex'
import Analytics from '@/lib/analytics'

export default {
  components: {
    NumeraiUploadFile: () => import('@/components/shared/NumeraiUploadFile'),
    NumeraiModal: () => import('@/components/shared/NumeraiModal'),
  },
  props: {
    dialog: { type: Boolean, default: false },
    models: { type: Array, default: null },
    onClose: { type: Function, default: null },
    onSuccess: { type: Function, default: null },
    onUploadStart: { type: Function, default: null },
    onUploadEnd: { type: Function, default: null },
    source: { type: String, default: null },
  },
  data() {
    return {
      selectedModel: null,
      isUploading: false,
      errorMessage: null,
    }
  },
  computed: {
    modelSelectItems() {
      if (!this.models) {
        return []
      }
      return this.models.map(model => model.name.toUpperCase())
    },
    modelName() {
      return this.selectedModel && this.selectedModel.name.toUpperCase()
    },
    uploadText() {
      return 'Select File'
    },
  },
  watch: {
    models: function(newModels) {
      this.models = newModels
      this.selectedModel &&
        this.onModelChange(this.selectedModel.name.toUpperCase())
    },
  },
  created() {
    if (this.models && this.models.length) {
      this.selectedModel = this.models[0]
    }
  },
  methods: {
    ...mapActions(['showSnackBar']),
    reset() {
      this.isUploading = false
      this.errorMessage = null
    },
    onModelChange(modelName) {
      this.errorMessage = null
      this.selectedModel = this.models.filter(
        model => model.name.toUpperCase() === modelName,
      )[0]
    },
    onModelUploadStart() {
      this.onUploadStart && this.onUploadStart()
      this.errorMessage = null
      this.isUploading = true
    },
    onModelUploadEnd() {
      this.onUploadEnd && this.onUploadEnd()
      this.isUploading = false
    },
    handleFailure(errorMessage) {
      this.errorMessage = errorMessage
    },
    handleSuccess() {
      this.onSuccess && this.onSuccess()
      this.onClose()
      this.reset()
    },
    close() {
      this.reset()
      this.onClose()
    },
    track(action, description) {
      Analytics.track('hello numerai', {
        tournament: 'classic',
        action,
        description,
      })
    },
  },
}
</script>

<style scoped>
.upload-button {
  width: 120px;
}

.loading-spinner {
  animation: loader 1s infinite linear;
}

.error-message {
  color: var(--color-red);
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.filename {
  overflow-wrap: break-word;
}
</style>
